import gql from 'graphql-tag';

export const integrationFacetFragment = gql`
  fragment integrationFacetFragment on IntegrationFacet {
    dokkioClass
    count
    integrationID
  }
`;
export default integrationFacetFragment;
